import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

/* Masked line-by-line reveal. mode="load" runs on mount (hero); mode="view" on scroll. */
export const KineticLines = ({
  lines,
  className = "",
  lineClassName = "",
  mode = "view",
  delay = 0,
  stagger = 0.12,
}) => {
  const animate = { y: "0%", opacity: 1 };
  const initial = { y: "110%", opacity: 0 };
  const transition = (i) => ({
    duration: 1,
    delay: delay + i * stagger,
    ease: EASE,
  });

  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            initial={initial}
            {...(mode === "load"
              ? { animate }
              : { whileInView: animate, viewport: { once: true, amount: 0.4 } })}
            transition={transition(i)}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export const Parallax = ({ children, distance = 60, className = "" }) => (
  <motion.div
    className={className}
    initial={{ y: distance / 2 }}
    whileInView={{ y: -distance / 2 }}
    viewport={{ once: false, amount: 0.1 }}
    transition={{ ease: "linear", duration: 0 }}
    style={{ willChange: "transform" }}
  >
    {children}
  </motion.div>
);
